import type {
  PaymentCreateOrderInput,
  PaymentCreateOrderResponse,
  PaymentOrdersResponse,
  PaymentOrderStatus,
  PaymentProductsResponse,
} from '@/types';

import { request } from './client';

export const PaymentApi = {
  getProducts(): Promise<PaymentProductsResponse> {
    return request<PaymentProductsResponse>('/payment/products');
  },

  createOrder(input: PaymentCreateOrderInput): Promise<PaymentCreateOrderResponse> {
    return request<PaymentCreateOrderResponse>('/payment/orders', {
      method: 'POST',
      body: JSON.stringify({
        product_id: input.productId,
        payment_method_id: input.paymentMethodId,
      }),
    });
  },

  getOrder(orderId: string): Promise<PaymentOrderStatus> {
    return request<PaymentOrderStatus>(`/payment/orders/${encodeURIComponent(orderId)}`);
  },

  listOrders(input: { page: number; pageSize: number }): Promise<PaymentOrdersResponse> {
    const params = new URLSearchParams({
      page: String(input.page),
      page_size: String(input.pageSize),
    });
    return request<PaymentOrdersResponse>(`/payment/orders?${params.toString()}`);
  },

  refreshOrder(orderId: string): Promise<PaymentOrderStatus> {
    return request<PaymentOrderStatus>(`/payment/orders/${encodeURIComponent(orderId)}/refresh`, {
      method: 'POST',
    });
  },
};
